export enum CertificateTypesValidation {
  PopertyRequired = 1,
  ContactRequired = 0,
}
